/**
 * Vue reactive/ref proxies are not structured-cloneable in every browser.
 * All query/form/page payloads crossing the request boundary are converted to
 * plain JSON data first. This intentionally drops functions and undefined.
 */
export function toPlain<T>(value: T): T {
  if (value === null || value === undefined) return value
  return JSON.parse(JSON.stringify(value)) as T
}

export function cloneQuery<T extends Record<string, unknown>>(query: T): T {
  return toPlain(query)
}

export function cloneForm<T extends Record<string, unknown>>(form: T): T {
  return toPlain(form)
}
